import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import AuthGuard from "../components/feature/AuthGuard";
import LandingPage from "../pages/landing/page";
import LoginPage from "../pages/login/page";
import OverviewPage from "../pages/overview/page";
import DevicesPage from "../pages/devices/page";
import LivePage from "../pages/live/page";
import TasksPage from "../pages/tasks/page";
import MapsPage from "../pages/maps/page";
import KnowledgePage from "../pages/knowledge/page";
import OpsPage from "../pages/ops/page";
import NetworkPage from "../pages/network/page";
import ReportsPage from "../pages/reports/page";
import SettingsPage from "../pages/settings/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/console",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <OverviewPage /> },
    ],
  },
  {
    path: "/devices",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [{ index: true, element: <DevicesPage /> }],
  },
  {
    path: "/live",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [{ index: true, element: <LivePage /> }],
  },
  {
    path: "/tasks",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [{ index: true, element: <TasksPage /> }],
  },
  {
    // 「指挥舱」与「地图」已合并(2026-08-09):同一个指挥面。
    // /cockpit 保留为重定向, 免得旧链接/书签直接 404。
    path: "/cockpit",
    element: <Navigate to="/maps" replace />,
  },
  {
    path: "/maps",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [{ index: true, element: <MapsPage /> }],
  },
  {
    path: "/knowledge",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [{ index: true, element: <KnowledgePage /> }],
  },
  {
    path: "/ops",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [{ index: true, element: <OpsPage /> }],
  },
  {
    path: "/network",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [{ index: true, element: <NetworkPage /> }],
  },
  {
    path: "/reports",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [{ index: true, element: <ReportsPage /> }],
  },
  {
    path: "/settings",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [{ index: true, element: <SettingsPage /> }],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;